// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/64fbf0b799456f126963.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"5ab4cd53129a6cb1f4db","132":"46313ee2f7900404220e","133":"36e1caaa7223f57f2a88"}[chunkId] + ".chunk.js";
};